import { useEffect } from "react";

import { User, getPlanAddonsForFamilyUser } from "@ecologi/shared";
import { planTypes } from "../components/PlanSelectButtons";

interface Args {
  familyPlanIdForLocation: string;
  selectedPlanType: string;
  setNumLocalTrees: (num: number) => void;
  setSelectedFamilyPlanAddons: (addons: any) => void;
  setSelectedPlanId: (planId: string) => void;
  setSelectedPlanType: (planType: string) => void;
  user: User | null;
}

// If there is a user trying to change their subscription,
// make sure to select their currently selected plan
export const usePlanEffects = ({
  familyPlanIdForLocation,
  selectedPlanType,
  setNumLocalTrees,
  setSelectedFamilyPlanAddons,
  setSelectedPlanId,
  setSelectedPlanType,
  user,
}: Args) => {
  useEffect(() => {
    if (
      user &&
      user.subscription &&
      !user.subscription.planId.includes("business")
    ) {
      // Upgrade plan name to pre-select item
      let newPlanId = user.subscription.planId.replace("v1", "v2");

      // UK planIds now include the -gbp suffix so add it
      newPlanId = ["personal-v2", "booster-v2", "mega-v2"].includes(newPlanId)
        ? newPlanId + "-gbp"
        : newPlanId;

      setSelectedPlanId(newPlanId);

      if (user.subscription.planId.includes("family")) {
        setSelectedPlanType(planTypes.family);
        setSelectedFamilyPlanAddons(getPlanAddonsForFamilyUser(user));
      } else {
        setSelectedPlanType(planTypes.personal);
      }

      const localProjectAddons = user.getLocalProjectAddons();
      if (localProjectAddons.length > 0) {
        setNumLocalTrees(localProjectAddons[0].quantity);
      }
    }
  }, [
    familyPlanIdForLocation,
    setNumLocalTrees,
    setSelectedFamilyPlanAddons,
    setSelectedPlanId,
    setSelectedPlanType,
    user,
  ]);

  // Make sure the addons are set when moving between tabs
  useEffect(() => {
    if (
      user &&
      user.subscription &&
      user.subscription.planId === familyPlanIdForLocation &&
      selectedPlanType === planTypes.family
    ) {
      setSelectedFamilyPlanAddons(getPlanAddonsForFamilyUser(user));
    }
  }, [
    familyPlanIdForLocation,
    selectedPlanType,
    setSelectedFamilyPlanAddons,
    user,
  ]);
};
